import React from 'react';
import { TextInput, DateInput, ReferenceInput, AutocompleteInput, BooleanInput, FormDataConsumer, usePermissions, useRecordContext, required } from 'react-admin';
import moment from 'moment';

import Edit, { EditActions } from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import TypeInput from './inputs/TypeInput';
import DurationInput from './inputs/DurationInput';
import HelpButton from './buttons/HelpButton';

const userOptionText = choice => choice?.fullname ? choice.fullname : '';

const validateLeave = (values) => {
    const errors = {};

    if (!moment(values.start_date).isSame(values.end_date, 'month')) {
        errors.start_date = 'Must be from the same month';
        errors.end_date = 'Must be from the same month';
    }
    if (!values.type) {
        errors.type = 'ra.validation.required';
    }
    if (!values.start_date) {
        errors.type = 'ra.validation.required';
    }
    if (!values.end_date) {
        errors.type = 'ra.validation.required';
    }

    return errors;
};

const LeaveActions = () => (
    <EditActions>
        <HelpButton />
    </EditActions>
);

const HalfDayInput = (props) => {
    const record = useRecordContext();

    return (
        <BooleanInput source="half_day" {...props} defaultValue={record?.duration === 0.5} />
    );
};

const LeaveEdit = (props) => {
    const { permissions } = usePermissions();

    return (
        <Edit {...props} actions={<LeaveActions />}>
            <SimpleForm validate={validateLeave}>
                <TextInput source="id" disabled />

                <ReferenceInput label="User" source="user_id" reference="users" sort={{ field: 'id', order: 'ASC' }}>
                    <AutocompleteInput optionText={userOptionText} size="small" disabled={!permissions?.includes('is_admin')} />
                </ReferenceInput>
                <TypeInput validate={required()}  />
                <DateInput source="start_date" validate={required()}  />
                <DateInput source="end_date" validate={required()}  />
                <FormDataConsumer>
                    {({ formData, ...rest }) => (
                        (formData.duration <= 1 && formData.duration > 0) && (
                            <HalfDayInput {...rest} />
                        )
                    )}
                </FormDataConsumer>
                <DurationInput readOnly={!permissions?.includes('is_admin')} />
                <TextInput source="description" multiline fullWidth rows="4" />
            </SimpleForm>
        </Edit>
    );
};

export default LeaveEdit;